import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faArrowUpRightFromSquare, faPlus } from '@fortawesome/free-solid-svg-icons'
import { isEqual } from 'lodash'
import Sparkles from '../assets/Sparkles'
import Button from 'react-bootstrap/Button'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { useAppDispatch, useAppSelector, useTemporaryTooltip } from '../hooks'
import { createNewThread } from '../features/completions/slice'
import { removeAllFiles } from '../features/files/slice'
import { getChannelState, isCreating, isProcessing } from '../features/completions/selectors'
import { isUploading } from '../features/files/selectors'
import { ChannelState } from '../types'

const SOLO_PATH = '/solo'

type Props = {
  close: () => void
}

function Header({ close }: Props) {
  const dispatch = useAppDispatch()
  const creating = useAppSelector(isCreating, isEqual)
  const processing = useAppSelector(isProcessing, isEqual)
  const channelState = useAppSelector(getChannelState, isEqual)
  const uploading = useAppSelector(isUploading, isEqual)
  const { show: showTooltip, trigger: showTooltipOnClick } = useTemporaryTooltip(500)
  const [disabled, setDisabled] = React.useState(false)

  const openInNewWindow = () => {
    window.open(SOLO_PATH, '_blank')
  }

  const handleNewChat = () => {
    if (!disabled) {
      showTooltipOnClick()
      dispatch(createNewThread())
      dispatch(removeAllFiles())
    }
  }

  React.useEffect(() => {
    setDisabled(creating || processing || uploading || ChannelState.Connected !== channelState)
  }, [creating, processing, channelState, uploading])

  return (
    <div className='pilot-faw-header'>
      <div className='header-top-row'>
        <div className='title'>
          <Sparkles />
          Ask Solo
        </div>
        <div className='actions'>
          <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip id='tooltip-new-chat'>New Chat</Tooltip>}
            show={showTooltip || undefined}
            trigger={['hover', 'focus']}
          >
            <Button variant='primary' onClick={handleNewChat} disabled={disabled}>
              <FontAwesomeIcon icon={faPlus} />
            </Button>
          </OverlayTrigger>
          <Button variant='primary' onClick={() => close()}>
            <FontAwesomeIcon icon={faChevronDown} />
          </Button>
          <Button variant='primary' onClick={() => openInNewWindow()}>
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
          </Button>
        </div>
      </div>
      <div className='subtitle'>Built on Open AI's ChatGPT 4o | Passed the bar and CPA exams</div>
    </div>
  )
}

export default Header
